package com.devi3east.bashbuddy.cart.domain.models

import kotlinx.serialization.Serializable

@Serializable
data class CartFeeBreakdown(
    val base: Long,
    val shipping: Long,
    val platformFee: Long,
    val stripeFee: Long,
    val total: Long
)